
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ContactSection from '@/components/ContactSection';

const Contact = () => {
  const { language } = useLanguage();
  
  const pageTitle = language === 'en' ? 'Contact | Attaboy Intelligence' : 'Contact | Attaboy Intelligence Artificielle';
  const pageDescription = language === 'en' 
    ? 'Get in touch with our team for inquiries about our AI solutions and services.' 
    : 'Contactez notre équipe pour des renseignements sur nos solutions et services d\'IA.';

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="pt-24">
          <div className="container mx-auto px-4 py-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
              {language === 'en' ? 'Contact Us' : 'Contactez-Nous'}
            </h1>
          </div>
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
